"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.space = void 0;
exports.space = [0, 4, 8, 16, 24, 32, 40, 64, 128, 256].map(n => n + 'px');
//# sourceMappingURL=spaces.js.map